import React, { useState, useEffect, Fragment, lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const UnsubscribeFromMailingList = lazy(() =>
  import(
    /* webpackChunkName: "UnsubscribeFromMailingList" */ "../components/UnsubscribeFromMailingList/UnsubscribeFromMailingList"
  )
);

// Redux stuff
import { connect } from "react-redux";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function unsubscribe(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Email Preferences - Content Generator`}
        description={`Update your Content Generator email preferences or unsubscribe from our mailing list. We respect your inbox - easily manage your subscription settings and communication preferences.`}
        url={`https://contentgenerator.io/unsubscribe`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <UnsubscribeFromMailingList />
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

export default connect(mapStateToProps)(unsubscribe);
